import React__default from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../tools/constants.js';

var propTypes = {
  /**
   * Content of the component
   */
  children: PropTypes.node.isRequired,
  /**
   * Used to set the aria-label for accessibility
   */
  ariaLabel: PropTypes.string,
  brand: PropTypes.oneOf(brands),
  /**
   * Use this prop to extend the styling according to your needs
   */
  classList: PropTypes.string,
  hasDisabledStyle: PropTypes.bool,
  /**
   * Use to convert the button as a link
   */
  href: PropTypes.string,
  /**
   * Lets users disable the button and also set aria-disabled
   */
  isDisabled: PropTypes.bool,
  /**
   * If true, button will take up full width of the container
   */
  isFullWidth: PropTypes.bool,
  /**
   * If true, button have a spinner before the text
   */
  isProcessing: PropTypes.bool,
  /**
   * Used to set the aria-label for accessibility
   */
  labelText: PropTypes.string,
  /**
   * used for user interactions
   */
  onClick: PropTypes.func,
  /**
   * [Target attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target)
   */
  target: PropTypes.string,
  theme: PropTypes.oneOf(['', 'inverse', 'seasonal', 'seasonal-inverse']),
  /**
   * [Button type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type)
   */
  type: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.oneOf(['', 'primary', 'secondary', 'tertiary-dark', 'tertiary-light', 'borderless', 'overlay'])
};
function Button(_ref) {
  var ariaLabel = _ref.ariaLabel,
    brand = _ref.brand,
    children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$hasDisabledStyle = _ref.hasDisabledStyle,
    hasDisabledStyle = _ref$hasDisabledStyle === void 0 ? false : _ref$hasDisabledStyle,
    href = _ref.href,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
    isProcessing = _ref.isProcessing,
    labelText = _ref.labelText,
    onClick = _ref.onClick,
    target = _ref.target,
    theme = _ref.theme,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    value = _ref.value,
    variant = _ref.variant;
  var buttonClasses = "button ".concat(classList);
  var buttonLabel = isProcessing ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "spin-container",
    "data-state": "processing",
    "data-testid": "spin-icon-container"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "spinner",
    "data-testid": "spin-icon"
  })), /*#__PURE__*/React__default.createElement("span", {
    "data-state": "processing"
  }, children)) : children;
  return href ? /*#__PURE__*/React__default.createElement("a", {
    className: buttonClasses,
    "aria-label": ariaLabel || labelText,
    "data-brand": brand || null,
    "data-full-width": isFullWidth,
    "data-theme": theme || null,
    "data-variant": variant,
    href: href,
    rel: target ? 'noreferrer noopener' : null,
    target: target
  }, buttonLabel) : /*#__PURE__*/React__default.createElement("button", {
    "aria-disabled": isDisabled,
    "aria-label": ariaLabel || labelText,
    className: buttonClasses,
    "data-brand": brand || null,
    "data-disabled": hasDisabledStyle,
    "data-full-width": isFullWidth,
    "data-theme": theme || null,
    "data-variant": variant,
    disabled: isDisabled,
    onClick: onClick,
    type: type,
    value: value
  }, buttonLabel);
}
Button.propTypes = propTypes;

export { Button as default };
//# sourceMappingURL=Button.js.map
